import React from 'react';
import { createContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { authRoutes, usePreviousLocation } from '@hooks/helpers/usePreviousLocation';

type INavigationContext = {
    previousPathname: string | null;
    handleBack: (backRoute?: string | (() => void)) => void;
};

export const NavigationContext = createContext<INavigationContext>({
    previousPathname: null,
    handleBack: () => {}
});

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();
    const previousPathname = usePreviousLocation();

    const handleBack = (backRoute?: string | (() => void)) => {
        const canGoBack =
            previousPathname && !authRoutes.includes(previousPathname) && window.history.length > 1;

        if (canGoBack) {
            navigate(-1);
        } else {
            if (typeof backRoute === 'string') {
                navigate(backRoute);
            } else if (typeof backRoute === 'function') {
                backRoute();
            } else {
                // Default fallback to dashboard
                navigate(routes.dashboard);
            }
        }
    };

    return (
        <NavigationContext.Provider
            value={{
                previousPathname,
                handleBack
            }}>
            {children}
        </NavigationContext.Provider>
    );
};
